<template>
  <div>
    <a-form layout="inline" @keyup.enter.native="searchQuery">
      <a-row :gutter="24">
        <a-col :md="6" :sm="8">
          <a-form-item label="ChannelType">
            <a-input placeholder="Please enterChannelType" v-model="form.channelType"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8">
          <a-form-item label="Channel">
            <a-input placeholder="Please enterChannel" v-model="form.payChannel"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8">
          <a-form-item label="ChannelName">
            <a-input placeholder="Please enterChannelName" v-model="form.payChannelName"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8">
          <a-form-item label="Package ID">
            <a-input placeholder="Please enterPackage ID" v-model="form.appSsid"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8">
          <a-form-item :label="'Jump to Web Browser Open/Close'">
            <a-select default-value="" style="width: 120px" v-model="form.browserOpen">
              <a-select-option value="">
                All
              </a-select-option>
              <a-select-option value="1">
                Enable
              </a-select-option>
              <a-select-option value="0">
                Close
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <span style="float: left; margin-top: 5px; display: block; margin-bottom: 24px;white-space: nowrap; " class="table-page-search-submitButtons">
            <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchQuery">{{ $t('search') }}</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">{{ $t('reset') }}</a-button>
            </a-col>
        </span>
      </a-row>
    </a-form>
    <div class="table-operator"  style="margin-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus">Add</a-button>
    </div>
    <a-table
      ref="table"
      size="middle"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      bordered>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('edit') }}</a>
        <a-divider type="vertical" />
        <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('more') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
                <a-menu-item>
                    <a-popconfirm :title="$t('confirmDelete')" @confirm="() => deleteCurrent(record)">
                        <a>{{ $t('delete') }}</a>
                    </a-popconfirm>
                </a-menu-item>
            </a-menu>
        </a-dropdown>
      </span>
    </a-table>
    <div style="margin-top: 15px; text-align: right;">
      <v-pagination
        v-if="total"
        :page-num="form.pageNum"
        :page-size="form.pageSize"
        :total="total"
        @change="handleTableChange" />
    </div>
    <pay-channel-info-modal ref="modalForm" @ok="modalFormOk"></pay-channel-info-modal>
  </div>
</template>
<script>
import { payChannelInfoList, payChannelInfoOperate,payChannelInfoDelete} from '@/webpublicapi/pay';
import payChannelInfoModal from './modules/payChannelInfoModal'

// const I18N_KEY = 'custServiceWorkOrder.';
export default {
  components: {
    payChannelInfoModal,
  },
  data () {
    return {
      // I18N_KEY,
      loading: false,
      total: 0,
      form: {
        pageNum: 1,
        pageSize: 30,
        payChannelName: undefined,
        payChannel: undefined,
        channelType: undefined,
        appSsid: undefined,
        browserOpen: undefined,
      },
      OPEN_STATUS: {
        0: 'Close',
        1: 'OpenStart',
      },
      visible: false,
      dataSource: [],
    }
  },
  computed: {
    // Table header
    columns () {
      return [
        {
          title: 'id',
          dataIndex: 'id',
          width:60,
          align:"center",
        },
        {
          title: 'BannerPath',
          align:"center",
          dataIndex: 'payBannerUrl',
        },
        {
          title: 'ChannelName',
          align:"center",
          dataIndex: 'payChannelName',
        },
        {
          title: 'Channel',
          align:"center",
          dataIndex: 'payChannel',
        },
        {
          title: 'Package ID',
          align:"center",
          dataIndex: 'appSsid',
        },
        {
          title: 'Jump to Web Browser Open/Close',
          dataIndex: 'browserOpen',
          align:"center",
          customRender: (text, record, index) => {
            return this.OPEN_STATUS[text];
          },
        },
        {
          title: 'Sort',
          align:"center",
          dataIndex: 'sort',
        },
        {
          title: 'ChannelType',
          align:"center",
          dataIndex: 'channelType',
        },
        {
          title: 'Created Time',
          align:"center",
          dataIndex: 'createTime',
        },
        {
          title: 'Updated Time',
          align:"center",
          dataIndex: 'updateTime',
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align:"center",
          scopedSlots: { customRender: 'action' },
        }
      ]
    },
  },
  created () {
    this.loadData('');
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    modalFormOk(data) {
      this.createInfo(data);
    },
    handleAdd () {
      this.infoId = undefined;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "Add";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit (record) {
      this.infoId = record.id;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "Edit";
      this.$refs.modalForm.disableSubmit = false;
    },
    changeModal (visible) {
      this.visible = visible;
    },
    deleteCurrent (row) {
      this.loading = true;
      payChannelInfoDelete(row.id).then(res => {
        this.$message.success(this.$t('success'));
        this.loadData(1);
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    createInfo (data) {
      console.log(data)
      const form = {
        ...data,
        id: this.infoId,
        opt: this.infoId ? '2' : '1',
      };
      payChannelInfoOperate(form).then(res => {
        this.$refs.modalForm.closeLoading();
        this.$refs.modalForm.close();
        this.$message.success('Added successfully');
        this.loadData(1);
      }).catch(e => {
        this.$refs.modalForm.closeLoading();
        this.$message.error(e.message);
      })
    },
    searchReset () {
      this.form = {
        payChannelName: undefined,
        payChannel: undefined,
        channelType: undefined,
        appSsid: undefined,
        browserOpen: undefined,
        pageNum: 1,
        pageSize: 30,
      }
    },
    loadData (pageNum) {
      if(pageNum) { this.form.pageNum = pageNum; }
      this.loading = true;
      payChannelInfoList(this.form).then(res => {
        this.loading = false;
        this.total = res.data.total
        this.dataSource = res.data.rows;
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    }
  }
}
</script>
<style scoped>
@import '~@/assets/less/common.less';
</style>
